import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Client-side navigation keeps the previous page's scroll position by default.
// Start every new page at the top, or at the #section a link points to (e.g. /service#faq).
export default function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    // Give the new page a moment to render the section before scrolling to it
    const timer = window.setTimeout(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      target?.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    }, 60);

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
